import React, { useEffect, useState } from "react"
import {
    BrowserRouter as Router,
    Navigate,
    Route,
    Routes,
} from "react-router-dom"
import Nav from "./components/LayoutComponents/Nav"
import { BoardingModal } from "./components/boardingModal/BoardingModal"
import CookiePrompt from "./components/CookiePrompt/CookiePrompt"
import SwipeablePages from "./components/SwipeablePages/SwipeablePages"
import useThemeColor from "./hooks/useThemeColor"
import { AnimatePresence } from "framer-motion"
import { PAGE_URLS } from "./constants/page-urls"
import { routes } from "./routes/routes"
import { useProfileStore } from "./state-management/profileStore"
import { useDataStore } from "./state-management/dataStore"
import { useShallow } from "zustand/react/shallow"

function App() {
    useThemeColor()
    const data = useDataStore((state) => state.data)
    // Cookies kanske inte behövs eftersom vi inte sparar någon personlig data
    const [showCookiePrompt, setShowCookiePrompt] = useState(false)
    const { setHasAllowedCookies, hasOnboarded } = useProfileStore(
        useShallow((state) => ({
            setHasAllowedCookies: state.setHasAllowedCookies,
            hasOnboarded: state.hasOnboarded,
        })),
    )

    // Visa kakprompt om inga preferenser för kakor valts
    useEffect(() => {
        const hasSetCookiePrefs = document.cookie.includes("profileData")
        setShowCookiePrompt(!hasSetCookiePrefs)
    }, [])

    // Lägg till alla props här som kan skickas till en sida
    // (vilka som faktiskt skickas till sidorna definieras i routes.js)
    const globalProps = {
        data,
    }

    return (
        <Router>
            <Routes>
                <Route
                    path="/*"
                    element={
                        <SwipeablePages
                            urls={routes.map((route) => route.path)}
                        >
                            <div
                                className={`h-full ${hasOnboarded ? "app pb-safe-nav" : "app noscroll"}`}
                            >
                                {!hasOnboarded ? (
                                    <BoardingModal />
                                ) : (
                                    <>
                                        <div className="bg-color-1">
                                            <Routes>
                                                {routes.map((route) => (
                                                    <Route
                                                        key={route.path}
                                                        path={route.path}
                                                        element={
                                                            <route.element
                                                                {...route.getProps(
                                                                    globalProps,
                                                                )}
                                                            />
                                                        }
                                                    />
                                                ))}
                                                {/* Catchall route innanför "/app/" */}
                                                <Route
                                                    path="*"
                                                    element={
                                                        <Navigate
                                                            to={PAGE_URLS.HOME}
                                                            replace
                                                        />
                                                    }
                                                />
                                            </Routes>
                                        </div>
                                        <Nav />
                                    </>
                                )}
                            </div>
                        </SwipeablePages>
                    }
                />
                {/* Den här routen är en catchall för när man är utanför /app/ */}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>

            {showCookiePrompt && (
                <AnimatePresence mode="wait">
                    <CookiePrompt
                        key={"cookiePrompt"}
                        onAccept={() => {
                            setHasAllowedCookies(true)
                            setShowCookiePrompt(false)
                        }}
                        onDecline={() => {
                            setHasAllowedCookies(false)
                            setShowCookiePrompt(false)
                        }}
                        visible={true}
                    />
                </AnimatePresence>
            )}
        </Router>
    )
}

export default App
